import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { UserInfo } from 'types/user';

export interface UserInfoState extends UserInfo {
  isLoading: boolean;
  isAdmin: boolean;
}

// 默认保留菜单
const defaultMenus = [
  {
    id: 1000,
    parentId: 0,
    title: 'sop',
    level: 0,
    sort: 1000,
    name: 'sop',
    icon: '',
  },
  {
    id: 10001,
    parentId: 0,
    title: '个人中心',
    level: 0,
    sort: 1000,
    name: 'user-center',
    icon: '',
  },
];

const initialState: UserInfoState = {
  isLoading: true,
  userId: 0,
  username: '',
  nickName: '',
  menus: [...defaultMenus],
  roles: [],
  resources: [],
  shop: undefined,
  isAdmin: false,
  subShop: [],
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    initUserInfo: (state, action: PayloadAction<UserInfo>) => {
      const {
        userId,
        username,
        menus,
        roles,
        shop,
        resources,
        nickName,
        subShop,
      } = action.payload;

      state.isLoading = false;
      state.userId = userId;
      state.username = username;
      state.nickName = nickName;
      state.menus = [...menus, ...state.menus];
      state.roles = roles;
      state.shop = shop || undefined;
      state.resources = resources || [];
      state.isAdmin = username === 'admin' || username === 'shilei';
      state.subShop = subShop || [];
    },
  },
});

export const { initUserInfo } = userInfoSlice.actions;

export const selectUserInfo = (state: RootState) => state.userInfo;

export default userInfoSlice.reducer;
